import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
    tagLabel: () => ({
        fontSize: 14,
    }),
}));
